import { ApiKey, BaseUrl } from '../global'
import axios from 'axios'

export const bookingSummaryReport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/bookingsummaryreport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}


export const searchConsignment = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/Tracking', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

export const searchConsignment_2 = async (cn) => {
    try {
        const rs = await axios.get('https://tracking.mulphilog.com.pk/api/CNTracking/3?consignment=' + cn, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data[0];
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

export const SingleConsignmentTracking = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/SingleConsignmentTracking', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

export const getNonVoidCNs = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/GetNonVoidCNs', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

//Komal Reports 29-oct-2021 Start
export const consigneeprofilereport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/ConsigneeProfileReport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}
export const qsrreport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/qsrreport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

export const qsronicreport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/qsronicreport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

export const getOsansa = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/ConsignmentOSANSA', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

export const getCustomerVoidCns = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/CustomerVoidCns', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}


export const customersummaryreport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/customersummaryreport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

export const customersummarydetailreport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/customersummarydetailreport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}
export const reversepickupreport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/reversepickupreport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}
export const paymentinstrumentreport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/paymentinstrumentreport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}
export const paymentinstrumentdetailreport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/paymentinstrumentdetailreport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

//Komal Reports 29-oct-2021 End

//Komal Reports 17-Mar-2022 Start
export const invoicesummaryreport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/invoicesummaryreport', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}

export const customerdetailreport = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/GetTilesReports', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}
//Komal Reports 17-Mar-2022 End

export const prepaymentsreports = async (accountNo) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/reports/PrepaymentReport?accountno=' +accountNo, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const BulkTrackingAPI = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/reports/BulkTracking', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e }
    }
}